export const shouldLoad = () => document.querySelector('.klt-table-cell--user-info__password') !== undefined;